<eo-base-form-control
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicableLabel]="notApplicableLabel"
  [notApplicable]="notApplicable"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <p-treeSelect
    attr.aria-describedby="{{ id }}-help"
    containerStyleClass="w-full {{ getInputStyleClass() }}"
    [id]="id"
    [tabindex]="getTabIndex().toString()"
    [options]="getOptions()"
    [placeholder]="getPlaceholder()"
    [formControl]="getFormControl()"
    [showClear]="getShowClear()"
    [filter]="hasFilter()"
    [filterBy]="getFilterBy()"
    [filterPlaceholder]="getFilterPlaceholder()"
    [appendTo]="getAppendTo()"
    [virtualScroll]="getVirtualScroll()"
    [virtualScrollItemSize]="getVirtualScrollSize()"
    [loading]="getLoading()"
    (onChange)="change.emit($event)"
    (onFocus)="focus.emit($event)"
    (onBlur)="blur.emit($event)"
    (onFilter)="onFilter.emit($event)"
  >
    <ng-content />
  </p-treeSelect>
</eo-base-form-control>
